export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const GUEST_ACCESS_TASK_INPUT_VALUE = 'guest_access_task_input_value';
